export default __webpack_public_path__ + "Encompass_Logo.svg";